import { gql } from 'graphql-tag';
export const oecExportJobQuery = gql`
  query oecExportJobQuery($surveyId: ID!, $id: ID!) {
    analysisExportJob(surveyId: $surveyId, id: $id) {
      id
      status
      file {
        downloadLink
        name
      }
    }
  }
`;